import { render } from "./Roadmaps.vue?vue&type=template&id=14573881"
import script from "./Roadmaps.vue?vue&type=script&lang=ts"
export * from "./Roadmaps.vue?vue&type=script&lang=ts"
script.render = render

export default script